"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactDom = _interopRequireDefault(require("react-dom"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var ReactSortableHoc = _interopRequireWildcard(require("react-sortable-hoc"));

var ReactOverlays = _interopRequireWildcard(require("react-overlays"));

var _reactTexty = _interopRequireDefault(require("react-texty"));

var _faker = _interopRequireDefault(require("faker"));

var _reactBaseTable = _interopRequireWildcard(require("react-base-table"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// import BaseTableExpandIcon from 'react-base-table/ExpandIcon'
var generateColumns = function generateColumns() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'column-';
  var props = arguments.length > 2 ? arguments[2] : undefined;
  return new Array(count).fill(0).map(function (column, columnIndex) {
    return _objectSpread(_objectSpread({}, props), {}, {
      key: "".concat(prefix).concat(columnIndex),
      dataKey: "".concat(prefix).concat(columnIndex),
      title: "Column ".concat(columnIndex),
      width: 150
    });
  });
};

var generateData = function generateData(columns) {
  var count = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'row-';
  return new Array(count).fill(0).map(function (row, rowIndex) {
    return columns.reduce(function (rowData, column, columnIndex) {
      rowData[column.dataKey] = "Row ".concat(rowIndex, " - Col ").concat(columnIndex);
      return rowData;
    }, {
      id: "".concat(prefix).concat(rowIndex),
      parentId: null
    });
  });
};

var noop = function noop() {};

var delay = function delay(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
};

var action = function action(message) {
  return function (args) {
    return console.log(message, args);
  };
};

var Table = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_reactBaseTable["default"], _extends({
    ref: ref,
    width: 700,
    height: 400
  }, props));
});

Table.Column = _reactBaseTable.Column;
var _default = {
  React: _react["default"],
  ReactDOM: _reactDom["default"],
  styled: _styledComponents["default"],
  css: _styledComponents.css,
  keyframes: _styledComponents.keyframes,
  createGlobalStyle: _styledComponents.createGlobalStyle,
  ReactSortableHoc: ReactSortableHoc,
  ReactOverlays: ReactOverlays,
  ReactTexty: _reactTexty["default"],
  faker: _faker["default"],
  BaseTable: _reactBaseTable["default"],
  Column: _reactBaseTable.Column,
  SortOrder: _reactBaseTable.SortOrder,
  AutoResizer: _reactBaseTable.AutoResizer,
  normalizeColumns: _reactBaseTable.normalizeColumns,
  callOrReturn: _reactBaseTable.callOrReturn,
  unflatten: _reactBaseTable.unflatten,
  BaseTableRow: _reactBaseTable.TableRow,
  BaseTableHeader: _reactBaseTable.TableHeader,
  // BaseTableExpandIcon,
  generateColumns: generateColumns,
  generateData: generateData,
  noop: noop,
  delay: delay,
  action: action,
  Table: Table
};
exports["default"] = _default;